import { forwardRef, type Ref, type SVGProps } from "react";
const IconWrenchFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.404 2.066c.223.084.436.169.65.262a8.1 8.1 0 0 1 5.071 7.28 7.76 7.76 0 0 1-3.11 6.099 9.3 9.3 0 0 1-2.24 1.302l.79 8.356a4.58 4.58 0 0 1-2.265 4.012c-1.42.83-3.176.83-4.597 0a4.58 4.58 0 0 1-2.263-4.012l.788-8.356a9.4 9.4 0 0 1-2.244-1.302 7.76 7.76 0 0 1-3.109-6.1 8.1 8.1 0 0 1 5.07-7.279q.318-.138.65-.262a1.016 1.016 0 0 1 1.377.953v5.572c.002.56.455 1.015 1.014 1.016h2.027a1.02 1.02 0 0 0 1.014-1.016V3.019a1.02 1.02 0 0 1 1.377-.953m-3.365 23.97a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconWrenchFilledSVG);
ForwardRef.displayName = "IconWrenchFilled";
export { ForwardRef as IconWrenchFilled };
